import { useLocation } from 'react-router-dom';

const useCurrentTab = () => {
  const location = useLocation();

  if (location.pathname.includes('/libTranslations')) return 'libTranslations';
  if (location.pathname.includes('/stripesApps')) return 'stripesApps';
  if (location.pathname.includes('/permsNames')) return 'permsNames';

  return 'libTranslations';
};

export default useCurrentTab;
